import React, { Component } from 'react';
import { arrayOf, bool, func, number, shape, string } from 'prop-types';
import CheckboxInput from 'ps-components/Input/CheckboxInput';
import ListItem from '../ListItem/ListItem';
import Table from 'ps-components/Table/Table/Table';
import TableBody from 'ps-components/Table/TableBody/TableBody';
import TableHeader from 'ps-components/Table/TableHeader/TableHeader';
import ReactTooltip from 'react-tooltip';
import './List.scss';

class List extends Component {
  static propTypes = {
    data: arrayOf(
      shape({
        id: string,
        orgJob: shape({
          id: string
        }),
        surveyJob: shape({
          code: string,
          description: string,
          id: string,
          survey: shape({
            code: string,
            id: string,
            name: string
          }),
          title: string
        })
      })
    ),
    onClick: func,
    selectAll: func,
    selectedItems: arrayOf(string),
    showSurveyJobDescription: bool
  };

  selectAllSurveyJobsMatches = () => {
    const { selectAll } = this.props;
    selectAll();
  };

  render() {
    const { data, onClick, selectedItems, showSurveyJobDescription } = this.props;
    const COLUMNS = [
      <CheckboxInput
        key="column-0"
        checked={data.length === selectedItems.length}
        className="select-all__input"
        onClick={this.selectAllSurveyJobsMatches}
      />,
      'Survey Job',
      'Survey',
      // 'Priority',
      'Participation'
    ];

    return (
      <div className="list__table">
        <Table>
          <TableHeader
            cellClass="list__table-header-cell pxl-text-muted pxl-text-xsmall"
            columns={COLUMNS}
            headerClass="list__table-header"
          />
          <TableBody className="list__table-body">
            {data.map((datum, index) => (
              <ListItem
                datum={datum}
                key={index}
                onClick={onClick}
                selectedItems={selectedItems}
                showSurveyJobDescription={showSurveyJobDescription}
              />
            ))}
          </TableBody>
        </Table>
        <ReactTooltip id="gjm-merit-match-indicator" effect="solid">
          <span>Match from Market Pricing</span>
        </ReactTooltip>
      </div>
    );
  }
}

export default List;
